import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** Uploads a document. */
export const executeUpload = store.effects.create((feature: Feature) =>
  feature.actions.upload.request.observe().pipe(
    // mergeMap (not exhaustMap): multiple files can upload concurrently.
    rxjs.mergeMap(action =>
      feature.api.upload(action.data.input, action.data.file).pipe(
        rxjs.map(() =>
          feature.actions.upload.success.from(action).create({
            request: action.data,
            response: undefined,
          }),
        ),
        rxjs.catchError((error: Error) =>
          rxjs.of(
            feature.actions.upload.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      ),
    ),
  ),
)
